export default __webpack_public_path__ + "static/media/dialogue-africa-learn-swahili-tanzania-kenya-logo.beadc139.png";